import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Chip, MenuItem, Select, TextField } from "@mui/material";
import enLocale from "date-fns/locale/en-GB";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { INotifyGet } from "../../../../pages/AdminConsole/NotifyAdminManagement/module/constants";
import {
  formatDateFromDDMMYYYYToMilliseconds,
  formatDateFromMillisecondsStringToDDMMYYYY,
} from "../../../../utils/utils";
import { CssTextField } from "../../../TextInputField/TextInputField";
import ConfirmModal from "../../ConfirmModal/ConfirmModal";
import ResponseModal from "../../ResponseModal/ResponseModal";
import classes from "./AddEditNotifyModal.module.scss";
import { fieldsList, IAddEditModalProp } from "./module/constants";
import messages from "./module/messages";

const AddEditNotifyModal = (props: IAddEditModalProp) => {
  const {
    size,
    responseUpdateState,
    isEdit,
    toEdit,
    sendUpdate,
    sendNew,
    onCloseResponse,
    allRoles,
  } = props;

  const [showResponseModal, setShowResponseModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [edited, setEdited] = useState(false);
  const [showConfirmButton, setShowConfirmButton] = useState(false);

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [startDate, setStartDate] = useState("");
  const [date, setDate] = useState(0);
  const [roles, setRoles] = useState([] as string[]);

  useEffect(() => {
    if (props.show === false) {
      setEdited(false);
      setShowConfirmButton(false);
      setStartDate("");
      setDate(0);
      setRoles([]);
    }
  }, [props.show]);

  useEffect(() => {
    if (toEdit !== null) {
      if (toEdit.roleList && toEdit.roleList !== "")
        setRoles(toEdit.roleList.split(", "));
      if (toEdit.startDate && toEdit.startDate !== "") {
        setStartDate(toEdit.startDate);
        setDate(formatDateFromDDMMYYYYToMilliseconds(toEdit.startDate));
      }
    }
  }, [toEdit]);

  useEffect(() => {
    if (isEdit) {
      if (
        edited &&
        (toEdit.title !== title ||
          toEdit.message !== message ||
          toEdit.startDate !== startDate ||
          toEdit.roleList !== roles.join(", "))
      )
        setShowConfirmButton(true);
      else setShowConfirmButton(false);
    } else {
      //is new notify
      if (
        title !== "" &&
        message !== "" &&
        startDate !== "" &&
        roles.length > 0
      )
        setShowConfirmButton(true);
      else setShowConfirmButton(false);
    }
  }, [title, message, startDate, roles]);

  const handleOkBtn = () => {
    setShowResponseModal(false);
    onCloseResponse();
  };

  const handleConfirmBtn = () => {
    setShowConfirmModal(true);
  };

  const handleCancelOp = () => {
    setShowConfirmModal(false);
  };

  const handleConfirmUpdate = () => {
    let data: INotifyGet;
    if (isEdit)
      data = {
        id: toEdit.uniqueId,
        title: title.length > 0 ? title : toEdit.title,
        message: message.length > 0 ? message : toEdit.message,
        startDate:
          startDate !== ""
            ? formatDateFromDDMMYYYYToMilliseconds(startDate)
            : formatDateFromDDMMYYYYToMilliseconds(toEdit.startDate),
        roles: roles,
      };
    else
      data = {
        title: title.length > 0 ? title : toEdit.title,
        message: message.length > 0 ? message : toEdit.message,
        startDate: formatDateFromDDMMYYYYToMilliseconds(startDate),
        roles: roles,
      };

    if (isEdit) sendUpdate(data);
    else sendNew(data);

    props.setShow(false);
    setShowConfirmModal(false);
    setShowResponseModal(true);
  };

  const handleDate = (val: Date | null) => {
    if (val) {
      setDate(val.getTime());
      setStartDate(
        formatDateFromMillisecondsStringToDDMMYYYY(val.getTime().toString())
      );
      setEdited(true);
    }
  };

  const handleSelect = (val: any) => {
    let list = new Set(roles);
    list.add(val.target.value);
    setRoles(Array.from(list));
    setEdited(true);
  };

  const handleRemoveRole = (role: string) => {
    let list = roles.filter((r) => r !== role);
    setRoles(list);
    setEdited(true);
  };

  return (
    <>
      <ResponseModal
        show={showResponseModal}
        onClose={handleOkBtn}
        state={responseUpdateState}
        showSuccessForwardMessage={true}
      />

      <ConfirmModal
        show={showConfirmModal}
        onCancel={handleCancelOp}
        onConfirm={handleConfirmUpdate}
      />

      <Modal
        show={props.show}
        size={size ? size : "lg"}
        onHide={props.onClose}
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.titleModal} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div style={{ marginTop: "10px" }}>
              {/* <span>
                <FormattedMessage {...messages.title} />
              </span> */}
              <TextField
                className={classes["textfield-input"]}
                key={`${fieldsList.title}`}
                id={`${fieldsList.title}`}
                label={fieldsList.title}
                variant="filled"
                size="small"
                fullWidth
                //disabled={isEdit}//====================TODO
                defaultValue={toEdit ? toEdit.title : ""}
                onChange={(e: any) => {
                  setTitle(e.target.value);
                  setEdited(true);
                }}
              />
            </div>
            <div style={{ marginTop: "10px" }}>
              {/* <span>
                <FormattedMessage {...messages.text} />
              </span> */}
              <TextField
                className={classes["textfield-input"]}
                key={`${fieldsList.text}`}
                id={`${fieldsList.text}`}
                label={fieldsList.text}
                variant="filled"
                size="small"
                multiline
                rows={5}
                fullWidth
                //disabled={isEdit}//====================TODO
                defaultValue={toEdit ? toEdit.message : ""}
                onChange={(e: any) => {
                  setMessage(e.target.value);
                  setEdited(true);
                }}
              />
            </div>
            <div style={{ marginTop: "10px" }}>
              {/* <span>
                <FormattedMessage {...messages.date} />
              </span> */}
              <div className={classes["datepick"]}>
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  locale={enLocale}
                >
                  <DatePicker
                    label={<FormattedMessage {...messages.date} />}
                    value={date !== 0 ? date : null}
                    onChange={(newValue: Date | null) => handleDate(newValue)}
                    renderInput={(params) => (
                      <CssTextField
                        className={classes["date-field"]}
                        variant="filled"
                        {...params}
                      />
                    )}
                    showTodayButton
                    views={["year", "month", "day"]}
                  />
                </LocalizationProvider>
              </div>
            </div>
            <div style={{ marginTop: "10px" }}>
              {/* <span>
                <FormattedMessage {...messages.roles} />
              </span> */}
              <Select
                className={classes["textarea"]}
                variant="filled"
                fullWidth
                label={fieldsList.roles}
                value={"default"}
                onChange={(val) => handleSelect(val)}
              >
                <MenuItem key={"default"} value={"default"} disabled>
                  <FormattedMessage {...messages.roles} />
                </MenuItem>
                {allRoles &&
                  allRoles.length > 0 &&
                  allRoles.map((r) => {
                    return (
                      <MenuItem key={r} value={r}>
                        {r}
                      </MenuItem>
                    );
                  })}
              </Select>
            </div>
            <div className={classes["chip-wrapper"]}>
              {roles &&
                roles.length > 0 &&
                roles.map((r) => {
                  return (
                    <Chip
                      className={classes["chips"]}
                      label={`${r}`}
                      key={r}
                      onDelete={() => handleRemoveRole(r)}
                    />
                  );
                })}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={props.onClose}
          >
            <FormattedMessage {...messages.close} />
          </button>
          <button
            className={`${classes.btn} ${classes["btn-confirm"]}`}
            onClick={handleConfirmBtn}
            disabled={!showConfirmButton}
          >
            <FormattedMessage {...messages.add} />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddEditNotifyModal;
